// extracted by mini-css-extract-plugin
export default {"boton":"CausaReaccionEditarScreen_boton__eEpPG"};